const ITEMS = ["United States", "Mexico", "Bulgaria", "Amsterdam", "135 banks", "29 countries", "High-risk welcome", "Cross-border settlement"];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative overflow-hidden border-y border-white/10 py-10" data-testid="jurisdiction-marquee" aria-label="Network jurisdictions">
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {[...row, ...row].map((t, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className={`font-display text-5xl font-light tracking-tight sm:text-7xl ${i % 2 ? "outline-text" : "text-slate-200"}`}>{t}</span>
            <span className="h-2.5 w-2.5 rotate-45 bg-[var(--gold)]" />
          </span>
        ))}
      </div>
    </section>
  );
}
